/** Free classified ads for anything placed through December 31, 2026 (New York time). Shared by the form, the server and the ads. */
export const FREE_CLASSIFIEDS_UNTIL = '2026-12-31';
export const FREE_CLASSIFIEDS_LABEL = 'through December 31';

export function classifiedsFreeNow(now: Date = new Date()) {
  const ny = new Date(now.toLocaleString('en-US', { timeZone: 'America/New_York' }));
  const today = `${ny.getFullYear()}-${String(ny.getMonth() + 1).padStart(2, '0')}-${String(ny.getDate()).padStart(2, '0')}`;
  return today <= FREE_CLASSIFIEDS_UNTIL;
}
